// src/pages/Users/Techniques/hooks/useTechniqueSpeech.js

import { useEffect, useMemo, useRef, useState } from "react";
import { hasJapaneseCharacters } from "../utils/speechUtils";

export default function useTechniqueSpeech(name) {
  const [toKanaFn, setToKanaFn] = useState(null);
  const triedImport = useRef(false);

  useEffect(() => {
    if (triedImport.current) return;

    triedImport.current = true;

    async function loadWanakana() {
      try {
        const mod = await import("wanakana");

        if (mod?.toKana) {
          setToKanaFn(() => mod.toKana);
        }
      } catch {
        // Wanakana est un confort, la page fonctionne sans.
      }
    }

    loadWanakana();
  }, []);

  return useMemo(() => {
    const raw = String(name || "").trim();

    if (!raw) return "";
    if (hasJapaneseCharacters(raw)) return raw;

    const cleaned = raw.replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();

    return toKanaFn ? toKanaFn(cleaned) : cleaned;
  }, [name, toKanaFn]);
}